




















import Vue from 'vue';

interface Icon {
  name: string
  mdiName: string
  link: string
}

export default Vue.extend({
  data() {
    return {
      icons: [
        {
          name: 'Github',
          mdiName: 'mdi-github',
          link: 'https://github.com/thomas-god/ges',
        },
      ] as Icon[],
    };
  },
});
